import { createFileRoute } from '@tanstack/react-router';
import { EmptyState } from '@/components/page-header';
import { TreeListPage } from '@/components/tracking/tree-list-page';
import { useT } from '@/lib/i18n';
import { useOrgId } from '@/lib/org';

export const Route = createFileRoute('/settings/classes')({ component: Classes });

/** Screen L1 (document 06): classes. */
function Classes() {
  const t = useT();
  const orgId = useOrgId();
  if (!orgId) return <EmptyState title={t('shell.selectClient')} />;
  return <TreeListPage kind="classes" />;
}
